import { h, Component } from 'preact';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import {
  actionHandler,
  changeFocusOnMaxLength,
} from '../../../utilities/form/formUtils';
import { getDateOfBirth } from '../../../utilities/form/formValidators';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import Error from '../../Form/Error';
import { replaceAll } from '../../../utilities/common';

class InputText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: Object.hasOwnProperty.call(props.values, props.id) ? props.values[props.id] : '',
    };

    this.getDateOfBirthFromCPR = getDateOfBirth.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  getAge(dateString) {
    if (dateString === null) {
      return 0;
    }
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  updateExtraFields(id, value, setFieldValue) {
    const dob = this.getDateOfBirthFromCPR(value);
    setFieldValue(`${id}-dob`, dob);
    setFieldValue(`${id}-age`, this.getAge(dob));
    setFieldValue(`${id}01`, value.substring(0, 6));
  }

  handleTextChange(event) {
    const {
      onChange,
      onBlur,
      maxLength,
      formValues,
      formValuesTemplate,
      actions,
      dispatch,
      values,
      setValues,
      id,
      setFieldValue,
    } = this.props;
    const { target: { value } } = event;

    // Forces onBlur to save data, when value.length is equal to it's maxLength
    if (maxLength && value.length === Number(maxLength)) {
      onBlur(event, formValues, formValuesTemplate);
    }

    this.setState({
      value,
    });
    this.updateExtraFields(id, value, setFieldValue);

    // Handle actions on input.
    if (actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  render() {
    const {
      id,
      desc,
      label,
      placeholder,
      onBlur,
      errors,
      touched,
      required,
      columns,
      mobileColumns,
      maxLength,
      endFocus,
      formValues,
      formValuesTemplate,
      isLoading,
      setFieldValue,
      translations,
    } = this.props;
    let { toggleType } = this.props;
    let { value } = this.state;

    const regex = new RegExp('(.*?)(([0-9]{1,6})[-]?([0-9]{0,4}))?(.*)');
    value = value.replace(regex, '$2');

    if (regex.test(value)) {
      if (value.length > 6) {
        value = value.replace(regex, '$3-$4');
      }
    }

    const formFieldClass = classNames(
      'form__field',
      'form__field--textfield', {
        'form__field--no-label': !label,
        [`form__field--${id}`]: id,
        [`form__field--${columns}col`]: columns,
        [`form__field--mobile-${mobileColumns}col`]: mobileColumns,
      },
      isLoading
    );

    const onTextBlur = (event) => {
      // Pass props needed for on blur event.
      onBlur(event, formValues, formValuesTemplate);
      this.updateExtraFields(id, value, setFieldValue);
    };

    if (!toggleType) {
      toggleType = 'tel';
    }

    return (
      <div className={formFieldClass}>

        {/* Label */}
        {label &&
          <Label id={id} label={label} />
        }

        {/* Input Field */}
        <input
          className="form__item"
          type={toggleType}
          id={id}
          name={id}
          placeholder={replaceAll(placeholder, translations, formValues)}
          onChange={this.handleTextChange}
          onInput={event => changeFocusOnMaxLength(
            event,
            endFocus,
            maxLength,
            this.handleTextChange
          )}
          onKeyPress={e => {
            if (e.key === 'Enter') e.preventDefault();
          }}
          onBlur={onTextBlur}
          required={required}
          maxLength={maxLength}
          endFocus={endFocus}
          value={value}
        />

        {/* Error Message */}
        <Error touched={touched} errors={errors} id={id} />

        {/* Description */}
        {desc &&
          <Description desc={desc} />
        }
      </div>
    );
  }
}

export default compose(
  connect((state) => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;

    return {
      translations,
    };
  })
)(InputText);

InputText.defaultProps = {
  required: false,
  placeholder: null,
  desc: null,
  label: null,
  maxLength: null,
  endFocus: null,
  mobileColumns: null,
  isLoading: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  toggleType: 'tel',
};

InputText.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.string,
  endFocus: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isLoading: PropTypes.string,
  values: PropTypes.array.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  toggleType: PropTypes.string,
  translations: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Input/CprText.jsx